import { useTranslation } from 'react-i18next';

import { ListingCard } from './listing-card';
import { localePath } from '../lib/format';
import { SITE_UI } from '@site-ui';
import { useLocale } from '@todo/core/i18n/use-locale';

// The design's three "Featured This Week" cards (no price), each leading to
// its list — what the home page and the empty lists show until the catalogs
// have rows. `exclude` drops the card that leads to the current page.
export function SampleCards({ exclude }: { exclude?: string }) {
  const { t } = useTranslation();
  const { locale } = useLocale();

  return SITE_UI.sampleCards.filter((card) => card.path !== exclude).map((card) => (
    <ListingCard
      key={card.key}
      href={localePath(locale, card.path)}
      imageUrl={card.image}
      imageAlt={t(`sample.${card.key}.alt`)}
      category={t(`sample.${card.key}.category`)}
      title={t(`sample.${card.key}.title`)}
      text={t(`sample.${card.key}.text`)}
      place={t(`sample.${card.key}.place`)}
    />
  ));
}
